import type { WithActiveBranchId } from '@app/api/shared';

export enum WarehouseInventoriesEndpoints {
  CreateWarehouseInventory = 'CreateWarehouseInventory',
  DeleteWarehouseInventory = 'DeleteWarehouseInventory',
  EditWarehouseInventory = 'EditWarehouseInventory',
  GetWarehouseInventoryById = 'GetWarehouseInventoryById',
  SearchInventories = 'SearchInventories',
  GetInventoriesSearchResult = 'GetInventoriesSearchResult',
  GetWarehouseInvetoryProducts = 'GetWarehouseInvetoryProducts',
  GetInventoryChanges = 'GetInventoryChanges',
  SetInventoryProductCount = 'SetInventoryProductCount',
  CompleteWarehouseInventory = 'CompleteWarehouseInventory',
  GetWarehouseInventoryReport = 'GetWarehouseInventoryReport',
  LevelUpInventoryReport = 'LevelUpInventoryReport',
  UpdateWarehouseInventoryProducts = 'UpdateWarehouseInventoryProducts',
  ExportInventoryReportToExcel = 'ExportInventoryReportToExcel',
}

export interface ModelCreateWarehouseInventory {
  WarehouseId: number;
  Comment?: string | null;
}

export enum ModelWarehouseInventoryState {
  Open = 'open',
  Done = 'done',
}

export interface ModelEditWarehouseInventory {
  Id: number;
  Comment?: string | null;
}

export interface ModelWarehouseInventory {
  Id: number;
  TimeCreated: string;
  UserId: number;
  UserName?: string | null;
  State?: ModelWarehouseInventoryState | null;
  IsDeleted: boolean;
  Comment?: string | null;
  WarehouseId: number;
  Warehouse?: string | null;
  CountProducts: number;
  CountFilled: number;
  CompletePercent: number;
}

export interface ModelInventoriesSearchFilter {
  WarehouseIds: number[] | null;
  ItemsPerPage: number;
  PageN: number;
}

export interface ModelInventoriesSearchResult {
  Id: number;
  Filter: ModelInventoriesSearchFilter;
  Inventories?: ModelWarehouseInventory[] | null;
  PageN: number;
  CountPages: number;
  CountInventories: number;
}

export interface ModelInventoryProduct {
  Id: number;
  CountWarehouse: number;
  CountInventory?: number | null;
  ProductId: number;
  Product?: string | null;
  Article?: string | null;
  BarCode?: string | null;
}

export interface ModelInventoryChange {
  Id: number;
  InventoryId: number;
  UserId: number;
  Timestamp: string;
  Count?: number | null;
  ProductId: number;
  Product?: string | null;
}

export interface ModelInventoryProductCount {
  Id: number;
  Count: number | null;
}

export interface ModelInventoryReportProduct {
  Id: number;
  CountWarehouse: number;
  CountInventory?: number | null;
  CountDifference: number;
  CostDifference: number;
  TotalLeftover?: number | null;
  PhysicalLeftover?: number | null;
  CreditLeftover?: number | null;
  HasCreditResidual: boolean;
  Unit?: string | null;
  ProductId: number;
  Product?: string | null;
  Article?: string | null;
  BarCode?: string | null;
}

export interface ModelInventoryReport {
  Inventory: ModelWarehouseInventory;
  Products: ModelInventoryReportProduct[] | null;
}

export type CreateWarehouseInventoryRequest = WithActiveBranchId<{
  data: ModelCreateWarehouseInventory;
}>;

export type DeleteWarehouseInventoryRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type EditWarehouseInventoryRequest = WithActiveBranchId<{
  data: ModelEditWarehouseInventory;
}>;

export type GetWarehouseInventoryByIdRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type SearchInventoriesRequest = WithActiveBranchId<{
  data: ModelInventoriesSearchFilter;
}>;

export type GetInventoriesSearchResultRequest = WithActiveBranchId<{
  searchId: number;
  pageN: number;
  itemsPerPage: number;
}>;

export type GetWarehouseInvetoryProductsRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type GetInventoryChangesRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type SetInventoryProductCountRequest = WithActiveBranchId<{
  data: ModelInventoryProductCount;
}>;

export type CompleteWarehouseInventoryRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type GetWarehouseInventoryReportRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type LevelUpInventoryReportRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type UpdateWarehouseInventoryProductsRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type ExportInventoryReportToExcelRequest = WithActiveBranchId<{
  inventoryId: number;
}>;

export type CreateWarehouseInventoryResponse = ModelWarehouseInventory;
export type DeleteWarehouseInventoryResponse = void;
export type EditWarehouseInventoryResponse = ModelWarehouseInventory;
export type GetWarehouseInventoryByIdResponse = ModelWarehouseInventory;
export type SearchInventoriesResponse = ModelInventoriesSearchResult;
export type GetInventoriesSearchResultResponse = ModelInventoriesSearchResult;
export type GetWarehouseInvetoryProductsResponse = ModelInventoryProduct[];
export type GetInventoryChangesResponse = ModelInventoryChange[];
export type SetInventoryProductCountResponse = void;
export type CompleteWarehouseInventoryResponse = ModelWarehouseInventory;
export type GetWarehouseInventoryReportResponse = ModelInventoryReport;
export type LevelUpInventoryReportResponse = void;
export type UpdateWarehouseInventoryProductsResponse = void;
export type ExportInventoryReportToExcelResponse = string;
